import * as PIXI from 'pixi.js'

// Funzione per caricare uno sprite nel canvas
const loadSprite = (img, options = {}) => {
  // Impostazioni predefinite per lo sprite
  const defaultOptions = {
    anchor: 0,
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
    width: 0,
    height: 0,
    wrapMode: PIXI.WRAP_MODES.CLAMP // Wrap mode predefinito
  }

  // Unione delle opzioni con quelle predefinite
  const spriteOptions = { ...defaultOptions, ...options }

  // Creazione della texture e dello sprite
  const texture = PIXI.Texture.from(img.src)
  const sprite = new PIXI.Sprite(texture)

  // Applicazione delle opzioni allo sprite
  sprite.anchor.set(spriteOptions.anchor)
  sprite.position.set(spriteOptions.x, spriteOptions.y)
  sprite.scale.set(spriteOptions.scaleX, spriteOptions.scaleY)

  // Se larghezza e altezza sono definite, le impostiamo
  if (spriteOptions.width > 0) sprite.width = spriteOptions.width
  if (spriteOptions.height > 0) sprite.height = spriteOptions.height

  // Imposta il wrapMode se specificato
  sprite.texture.baseTexture.wrapMode = spriteOptions.wrapMode

  return sprite
}

// Funzione per configurare l'applicazione PIXI
const setupApp = (target, sizes, filters = [], ...images) => {
  const [width, height] = sizes

  // Configurazione dell'applicazione PIXI
  const app = new PIXI.Application({
    width,
    height,
    resolution: devicePixelRatio || 1,
    autoDensity: true,
    antialias: true, // Migliora il rendering delle immagini
    backgroundColor: 0x010101
  })

  // Applicazione dei filtri allo stage
  if (filters.length) {
    app.stage.filters = filters
  }

  // Aggiunta degli sprite al canvas
  images.forEach((img) => {
    app.stage.addChild(img)
  })

  // Aggiunta del canvas al DOM
  target.appendChild(app.view)

  return app
}

// Funzione per impostare un filtro di displacement
const setupFilter = (sprite) => {
  return new PIXI.filters.DisplacementFilter(sprite)
}

export { loadSprite, setupApp, setupFilter }
